/* eslint react/sort-comp: 0 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getAdTargets } from '../../utils/ads/setAdTargeting';
import { componentIsInRangeOfViewport, documentIsVisible } from '../../utils/dom';
import {get} from 'lodash';
import classnames from 'classnames';

const LAZY_LOAD_CUSHION_PX = 300;
const AD_SIZE = 'fluid';

export default class NativeAd extends Component {
  constructor(props, context) {
    super(props, context);

    this.eventInitialized = false;

    this.state = {
      renderFallback: false
    };
  }

  componentDidMount() {
    if (this.shouldInitializeRenderEvent()) {
      this.initializeRenderEvent();
    }
  }

  componentDidUpdate() {
    if (this.shouldInitializeRenderEvent()) {
      this.initializeRenderEvent();
    }
  }

  handleSlotRenderEnded = (event) => {
    if (event.slot.getSlotElementId() === this.getId()) {
      this.setState({ renderFallback: event.isEmpty });
    }
  }

  getTargeting = () => {
    const { adsState } = this.props;
    const { ad_data } = adsState || {};
    const { location } = this.context;
    const targeting = getAdTargets(ad_data, location);
    return JSON.stringify(targeting, (key, value) => (typeof value === 'undefined') ? null : value);
  }

  getSlotId = () => {
    // returning an empty slot id disables slot registration for VICEMedia/web-ad-lib.
    const disableAllAds = get(this.props, 'adsState.ad_data.ad_disable_all_ads');
    return disableAllAds ? '' : 'native';
  }

  shouldInitializeRenderEvent = () => {
    if (this.eventInitialized) {
      return false;
    }

    const { location } = this.context;
    const { adTargetingCompleted } = this.props.adsState;
    const disableAllAds = get(this.props, 'adsState.ad_data.ad_disable_all_ads');

    return adTargetingCompleted
      && location.query.test !== 'off'
      && !disableAllAds;
  }

  initializeRenderEvent = () => {
    this.eventInitialized = true;
    window.htlbid.pubads().addEventListener('slotRenderEnded', this.handleSlotRenderEnded);
  }

  adIsVisible = () => {
    if (typeof window === 'undefined') {
      return false;
    }

    return documentIsVisible(document)
      && componentIsInRangeOfViewport(this._node, this.props.lazyLoadCushionPx, window);
  }

  getId = () => `ad-${this.props.uniqueId}`;

  render() {
    const adClasses = classnames('ad', this.props.className);
    const nativeAd = this.state.renderFallback ?
      this.props.fallbackElement :
      (
        <div
          className={adClasses}
          data-ad-size={AD_SIZE}
          data-ad-position={this.props.position}
          data-slot-id={this.getSlotId()}
          data-targeting={this.getTargeting()}
          id={this.getId()}
          ref={node => this._node = node}
        />
      );

    return (
      nativeAd
    );
  }
}

NativeAd.propTypes = {
  adsState: PropTypes.shape({
    ad_data: PropTypes.object,
    adTargetingCompleted: PropTypes.bool
  }).isRequired,
  uniqueId: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  className: PropTypes.string,
  lazyLoadCushionPx: PropTypes.number,
  fallbackElement: PropTypes.element
};

NativeAd.defaultProps = {
  adsState: {},
  lazyLoadCushionPx: LAZY_LOAD_CUSHION_PX
};

NativeAd.contextTypes = {
  channels: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.object
};
